import { UsersApi } from "@/api/users";
import { CreateAdminUserRequest } from "@/api/users/types/create-admin-user.types";
import { ResourceName } from "@/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotify } from "react-admin";
import { useUIStore } from "@/stores";

export const useCreateAdminUser = () => {
  const queryClient = useQueryClient();
  const notify = useNotify();
  const { closeModal } = useUIStore();

  const { mutate: createAdminUser, isPending } = useMutation({
    mutationFn: (body: CreateAdminUserRequest) =>
      UsersApi.createAdminUser(body),
    onError: (error) => {
      setTimeout(() => {
        notify(error, { type: "error" });
      }, 250);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ResourceName.ADMIN_USERS],
      });
      setTimeout(() => {
        notify("User is created!", { type: "success" });
      }, 250);
    },
    onSettled: () => {
      closeModal();
    },
  });

  return {
    createAdminUser,
    createAdminUserLoading: isPending,
  };
};
